var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTextToCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "browser-code") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,35a2,2,0,0,1-1.3-3.5L17,27l-5.3-4.5a2,2,0,0,1,2.6-3l7,6a2,2,0,0,1,0,3l-7,6A1.9,1.9,0,0,1,13,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,33H26a2,2,0,0,1,0-4H36a2,2,0,0,1,0,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,6H4A2,2,0,0,0,2,8V40a2,2,0,0,0,2,2H4a2.1,2.1,0,0,0,2-2.3V10H42V38H16a2,2,0,0,0-2,2.3A2.1,2.1,0,0,0,16.1,42H44a2,2,0,0,0,2-2V8A2,2,0,0,0,44,6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextToCode);
export default __webpack_public_path__ + "static/media/icon-textToCode.529ddd07980ec0af3e04a914dad8805b.svg";
export { ForwardRef as ReactComponent };